import { createSlice } from '@reduxjs/toolkit';
import {
  AddMoreSectionPostApi,
  UpdateAddMore,
  GetAddMoreById,
  DeleteAddMore,
} from '../services/AddMoreService';

export const AddMoreSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addMore: '',
    addmoreList: [],
    getaddMore: '',
    updateAddmore: '',
  },
  reducers: {
    getAddmore: (state, action) => {
      state.getaddMore = [action.payload];
    },
  },
});

export const InsertAddmore = (payload) => async () => {
  return AddMoreSectionPostApi(payload);
};

export const updateAddmoreList = (payload, expid) => async () => {
  return UpdateAddMore(payload, expid);
};

export const getaddMoreByuserId = () => async (dispatch) => {
  GetAddMoreById().then((response) => {
    dispatch(getAddmore(response.data));
  });
};

export const deleteAddmore = (data) => async () => {
  return DeleteAddMore(data);
};

export const { getAddmore } =
  AddMoreSlice.actions;
export default AddMoreSlice.reducer;
